import React from 'react';
import Link from '../../../../elements/Link';
import styles from './EventFormsButton.module.scss';
import {connectEventFormDrafts} from '../../../../connects';
import isLocalStorageSupported from '../../../../../misc/isLocalStorageSupported';

class EventFormsButton extends React.Component {
    render() {
        if (!isLocalStorageSupported) {
            return null;
        }

        let href;
        if (this.props.formDrafts.length) {
            href = './forms/drafts';
        } else if (this.props.forms.length == 1) {
            href = './forms/' + this.props.forms[0].id;
        } else {
            href = './forms';
        }
        return <Link className={styles.EventFormsButton} href={href} />;
    }
}

export default connectEventFormDrafts(EventFormsButton);
